import { render, staticRenderFns } from "./MarketplaceReviewsHead.vue?vue&type=template&id=500fc56e"
import script from "./MarketplaceReviewsHead.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsHead.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceReviewsHead.vue?vue&type=style&index=0&id=500fc56e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports